import React, { useState, useEffect } from 'react';
import { Description, Field, Label, Switch } from '@headlessui/react'

export const StepTrhee = (props) => {

    const [data, setData] = useState({
        idTowing: props.data.idTowing,
        craneList: props.data.craneList,
        crane: props.data.crane,
        loadingCranes: props.data.loadingCranes,
    })

    const handleChange = (prop, value) => {
        if(prop === 'idTowing'){
            if(value === true) {
                value = 1;
            }else{
                value = 0;
            }
        }
        setData((prevState) => ({
            ...prevState,
            [prop]: value, 
        }));
    }

    useEffect((props) => { 
        props.updateStepData('trhee', data)
    }, [data])

    return(
            <div style={{padding:50}}>
                <div className="px-4 sm:px-0">
                    <h3 className="text-base/7 font-semibold text-gray-900">Informacion de la grua</h3>
                    <p className="mt-1 max-w-2xl text-sm/6 text-gray-500"></p>
                </div>
                <div className="mt-6 border-t border-gray-100">
                    <dl className="divide-y divide-gray-100">
                        <Field className="flex items-center justify-between">
                            <span className="flex grow flex-col">
                                <Label as="span" passive className="text-sm/6 font-medium text-gray-900">
                                
                                </Label>
                                <Description as="span" className="text-sm text-gray-500">
                                 ¿ Este proceso requiere registrar o asignar una grua ?
                                </Description>
                            </span>
                            <Switch
                                checked={data.idTowing === 1 ? true : false}
                                onChange={(e) => {handleChange('idTowing', e)}}
                                className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                            >
                                <span
                                aria-hidden="true"
                                className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                />
                            </Switch>
                        </Field>
                    </dl>
                    <div>
                        {
                            data.idTowing === 1 ? 
                                <div style={{marginTop:20}}>
                                    {props.cranes?.map((crane) => {
                                        return(
                                            <div className="flex items-center">
                                                <fieldset>
                                                    <div className="space-y-5">
                                                        <div className="relative flex items-start">
                                                            <div className="flex h-6 items-center">
                                                                <input
                                                                    checked={data.crane === crane.id}
                                                                    onChange={() => {handleChange('crane', crane.id)}}
                                                                    id="comments"
                                                                    name="comments"
                                                                    type="checkbox"
                                                                    aria-describedby="comments-description"
                                                                    className="size-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                                                />
                                                            </div>
                                                            <div className="ml-3 text-sm/6">
                                                                <label htmlFor="comments" className="font-medium text-gray-900">
                                                                    {crane.name}
                                                                </label>
                                                                <p id="comments-description" className="text-gray-500">
                                                                    Identificacion: {crane.identification}
                                                                </p>
                                                                <p id="comments-description" className="text-gray-500">
                                                                    Placa: {crane.numberPlate}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        )
                                    })}
                                </div> : null
                        }
                    </div>
                </div>
            </div>
    )
}